import { Card, CardBody, Checkbox, Input } from '@nextui-org/react'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { AmountSlider } from '../amountslider/AmountSlider'
import MarketPreviewDetailsTable from '../assetpreview/MarketPreviewDetailsTable'
import MainButton from '../common/util/input/MainButton'
import get, { getDelphiMedian } from '../helpers/Api'
import { formatMarket, formatWAX, sleep } from '../helpers/FormatLinks'
import {
    getBoostAction,
    signAtomicMarketBuy,
    signNFTHiveBuy,
    signSimpleMarketBuy,
    signWaxplorerBuy,
} from '../helpers/WaxApi'
import { PopupLoadingIndicator } from '../loadingindicator/PopupLoadingIndicator'
import { MarketInfoDetails } from '../marketinfo/MarketInfoDetails'
import { useSharedState } from '../waxplorer/Waxplorer'
import ErrorMessage from './ErrorMessage'
import Popup from './Popup'

function BuyPopup(props) {
    const asset = props['asset']
    const listing = props['listing']

    const { t } = useTranslation('common')

    const [state] = useSharedState()

    const activeUser = state?.activeUser

    const userName = activeUser?.accountName
        ? state?.activeUser.accountName
        : null

    const callBack = props['callBack']
    const closeCallBack = props['closeCallBack']
    const [bought, setBought] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [error, setError] = useState()

    const [allAssets, setAllAssets] = useState(null)
    const [buyMultiple, setBuyMultiple] = useState(false)
    const [amountToBuy, setAmountToBuy] = useState(0)
    const [currentDisplayAction, setCurrentDisplayAction] = useState(0)
    const [successCount, setSuccessCount] = useState(0)
    const [errorCount, setErrorCount] = useState(0)
    const [maxActions, setMaxActions] = useState(1)

    const { assets, currency, price } = listing

    const bundle = assets?.length > 1

    let { market, listingId, symbol, seller } = listing

    let { name, image, assetId, schema, owner, template } = asset

    const assetIds = []

    const marketplace = market
    if (assets) {
        const a = assets[0]
        assetId = a.assetId
        owner = a.owner
        assets.forEach((asset) => assetIds.push(asset.assetId))
        schema = a.schema
        name =
            assets.length > 1 ? `${a.name} (Bundle of ${assets.length})` : name
        image = a.image
    } else {
        if (assetId) assetIds.push(assetId)
    }

    const getAllForSale = (templateId) => {
        get('get-all-for-sale/' + templateId, 'legacy').then((result) =>
            setAllAssets(result),
        )
    }

    useEffect(() => {
        if (template?.templateId && !symbol) {
            getAllForSale(template?.templateId)
        }
    }, [template])

    const multiBuy = async () => {
        setIsLoading(true)

        let currentAction = 0
        let errors = 0
        let successes = 0

        let usd_wax = await getDelphiMedian(state)
        usd_wax /= 10000

        let transactionId = null

        while (currentAction < amountToBuy / maxActions) {
            const start = currentAction * maxActions
            const end = start + maxActions
            const actions = [getBoostAction(activeUser)]

            const simpleassetsClaims = []

            for (const asset of allAssets
                .sort(
                    (a, b) =>
                        parseFloat(a.estimatedWaxPrice) -
                        parseFloat(b.estimatedWaxPrice),
                )
                .slice(start, end)) {
                let quantity = parseFloat(price)
                const listingId = asset.listingId
                const currency = asset.currency

                const marketplace = asset.market

                if (currency === 'USD') {
                    quantity = parseFloat(price) / usd_wax
                }

                switch (marketplace) {
                    case 'atomicmarket':
                        {
                            actions.push({
                                account: 'eosio.token',
                                name: 'transfer',
                                authorization: [
                                    {
                                        actor: userName,
                                        permission: activeUser.requestPermission
                                            ? activeUser.requestPermission
                                            : 'active',
                                    },
                                ],
                                data: {
                                    from: userName,
                                    to: 'atomicmarket',
                                    quantity: `${quantity.toFixed(8)} WAX`,
                                    memo: 'deposit',
                                },
                            })

                            actions.push({
                                account: 'atomicmarket',
                                name: 'purchasesale',
                                authorization: [
                                    {
                                        actor: userName,
                                        permission: activeUser.requestPermission
                                            ? activeUser.requestPermission
                                            : 'active',
                                    },
                                ],
                                data: {
                                    buyer: userName,
                                    sale_id: listingId,
                                    taker_marketplace:
                                        process.env.NEXT_PUBLIC_TESTNET ===
                                        'TRUE'
                                            ? 'nfthiveboost'
                                            : 'nft.hive',
                                    intended_delphi_median:
                                        currency === 'USD'
                                            ? Math.round(usd_wax * 10000)
                                            : 0,
                                },
                            })
                        }
                        break
                    case 'waxplorercom':
                        {
                            actions.push({
                                account: 'eosio.token',
                                name: 'transfer',
                                authorization: [
                                    {
                                        actor: userName,
                                        permission: activeUser.requestPermission
                                            ? activeUser.requestPermission
                                            : 'active',
                                    },
                                ],
                                data: {
                                    from: userName,
                                    to: 'waxplorercom',
                                    quantity: `${quantity.toFixed(8)} WAX`,
                                    memo: `purchase:${listingId}`,
                                },
                            })
                            simpleassetsClaims.push(assetId)
                        }
                        break
                    case 'simplemarket':
                        {
                            actions.push({
                                account: 'eosio.token',
                                name: 'transfer',
                                authorization: [
                                    {
                                        actor: userName,
                                        permission: activeUser.requestPermission
                                            ? activeUser.requestPermission
                                            : 'active',
                                    },
                                ],
                                data: {
                                    from: userName,
                                    to: 'simplemarket',
                                    quantity: `${quantity.toFixed(8)} WAX`,
                                    memo:
                                        '{"nftid": ' +
                                        assetId +
                                        ', "affiliate_id": 200001}',
                                },
                            })

                            simpleassetsClaims.push(assetId)
                        }
                        break
                    case 'waxinventory':
                        {
                            actions.push({
                                account: 'eosio.token',
                                name: 'transfer',
                                authorization: [
                                    {
                                        actor: userName,
                                        permission: activeUser.requestPermission
                                            ? activeUser.requestPermission
                                            : 'active',
                                    },
                                ],
                                data: {
                                    from: userName,
                                    to: 'waxinventory',
                                    quantity: `${quantity.toFixed(8)} WAX`,
                                    memo:
                                        '{"id":"' +
                                        assetId +
                                        '","type":"market"}',
                                },
                            })
                            simpleassetsClaims.push(assetId)
                        }
                        break
                }
            }

            if (simpleassetsClaims.length > 0) {
                actions.push({
                    account: 'simpleassets',
                    name: 'claim',
                    authorization: [
                        {
                            actor: userName,
                            permission: activeUser.requestPermission
                                ? activeUser.requestPermission
                                : 'active',
                        },
                    ],
                    data: {
                        claimer: userName,
                        assetids: simpleassetsClaims,
                    },
                })
            }

            try {
                const result = await activeUser.session.transact(
                    {
                        actions: actions,
                    },
                    {
                        expireSeconds: 300,
                        blocksBehind: 0,
                    },
                )

                if (result?.response?.transaction_id) {
                    successes += 1
                    setSuccessCount(successes)
                    transactionId = result?.response?.transaction_id
                }
            } catch (e) {
                console.error(e)
                setError(e.message)
                errors += 1
                setErrorCount(errors)
            } finally {
                currentAction += 1
                setCurrentDisplayAction(currentAction)
                if (currentAction < amountToBuy) {
                    await sleep(500)
                }
            }
        }
        setIsLoading(false)
        callBack({
            success: true,
            error: null,
            asset: asset,
            transactionId: transactionId,
        })
        closeCallBack()
    }

    const buy = async () => {
        let quantity = parseFloat(price)
        closeCallBack()
        setIsLoading(true)

        let usd_wax = 0

        if (currency === 'USD') {
            usd_wax = await getDelphiMedian(state)
            usd_wax /= 10000
            quantity = parseFloat(price) / usd_wax
        }

        try {
            let result
            switch (marketplace) {
                case 'atomicmarket':
                    {
                        result = await signAtomicMarketBuy(
                            activeUser,
                            listingId,
                            quantity,
                            currency,
                            usd_wax,
                        )

                        setBought(true)
                        callBack({
                            success: true,
                            error: null,
                            asset: asset,
                            transactionId: result?.response?.transaction_id,
                        })
                    }
                    break
                case 'waxplorercom':
                    {
                        result = await signWaxplorerBuy(
                            activeUser,
                            quantity,
                            listingId,
                            assetId,
                        )

                        setBought(true)
                        callBack({
                            success: true,
                            error: null,
                            asset: asset,
                            transactionId: result?.response?.transaction_id,
                        })
                    }
                    break
                case 'simplemarket':
                    {
                        result = await signSimpleMarketBuy(
                            activeUser,
                            quantity,
                            assetId,
                        )

                        setBought(true)
                        callBack({
                            success: true,
                            error: null,
                            asset: asset,
                            transactionId: result?.response?.transaction_id,
                        })
                    }
                    break
                case 'nft.hive':
                    {
                        result = await signNFTHiveBuy(
                            activeUser,
                            quantity,
                            listingId,
                        )

                        setBought(true)
                        callBack({
                            success: true,
                            error: null,
                            asset: asset,
                            transactionId: result?.response?.transaction_id,
                        })
                    }
                    break
            }
        } catch (e) {
            callBack({
                success: false,
                error: e.message,
                asset: asset,
            })
            setError(e.message)
            console.error(e)
        } finally {
            setIsLoading(false)
        }
    }

    const buyField = (
        <div className={'mx-2'}>
            <MainButton
                variant="solid"
                size="md"
                onClick={buyMultiple ? multiBuy : buy}
                disabled={buyMultiple && amountToBuy === 0}
            >
                {market === 'atomicmarket'
                    ? `${t('asset.buy')}`
                    : `${t('asset.buy')} (${formatMarket(
                          market ? market : owner,
                      )})`}
            </MainButton>
        </div>
    )

    const cancel = () => {
        callBack({ bought: false, error: null, asset: asset })
        closeCallBack()
    }

    const changeBuyMultiple = (e) => {
        setBuyMultiple(e)
        setAmountToBuy(0)
    }

    const changeAmountToBuy = (e) => {
        setAmountToBuy(e.target.value)
    }

    const increaseAmountToBuy = () => {
        const newAmount = Math.min(amountToBuy + 1, allAssets.length)
        if (newAmount > 0 && maxActions === 0) {
            setMaxActions(1)
        }
        setAmountToBuy(newAmount)
    }

    const decreaseAmountToBuy = () => {
        const newAmount = Math.max(amountToBuy - 1, 0)
        setAmountToBuy(newAmount)
        if (newAmount < maxActions && newAmount > 0) {
            setMaxActions(newAmount)
        }
    }

    const changeMaxActions = (e) => {
        const newValue = parseInt(e.target.value)
        setMaxActions(
            newValue > amountToBuy && amountToBuy > 0
                ? amountToBuy
                : newValue >= 1
                ? newValue
                : 1,
        )
    }

    const lowest = allAssets
        ? Math.min(...allAssets.map((item) => item.estimatedWaxPrice))
        : 0
    const highest = allAssets
        ? Math.max(...allAssets.map((item) => item.estimatedWaxPrice))
        : 0

    const totalPrice = allAssets
        ? allAssets
              .map((item) => item.estimatedWaxPrice)
              .sort((a, b) => a - b)
              .slice(0, amountToBuy)
              .reduce((b, a) => b + a, 0)
        : 0

    return (
        <Popup title={name} cancel={cancel} image={image} asset={asset}>
            {allAssets && allAssets.length > 1 && (
                <div className="flex flex-wrap w-full mb-2 text-sm xl:text-base">
                    <div className={'text-sm xl:text-base my-4'}>
                        <Checkbox
                            isSelected={buyMultiple}
                            onValueChange={changeBuyMultiple}
                            isDisabled={allAssets.length < 2}
                        >
                            {allAssets.length < 100
                                ? t(
                                      'popups.there_are_multiple_assets_for_sale_between_x_and_y',
                                      {
                                          asset: name,
                                          x: formatWAX(lowest),
                                          y: formatWAX(highest),
                                      },
                                  )
                                : t(
                                      'popups.there_are_over_100_assets_for_sale_starting_at_x',
                                      { asset: name, x: formatWAX(lowest) },
                                  )}
                        </Checkbox>
                    </div>

                    {buyMultiple && (
                        <Card className="mb-4">
                            <CardBody>
                                {buyMultiple && (
                                    <div className={'w-full my-4'}>
                                        <AmountSlider
                                            title={t('popups.amount_to_buy')}
                                            disabled={!buyMultiple}
                                            currentAmount={amountToBuy}
                                            changeAmount={changeAmountToBuy}
                                            increaseAmount={increaseAmountToBuy}
                                            decreaseAmount={decreaseAmountToBuy}
                                            max={allAssets.length}
                                        />
                                    </div>
                                )}

                                {buyMultiple && (
                                    <div className="w-full space-y-4 md:my-auto">
                                        <p className="text-sm">
                                            {t(
                                                'popups.items_per_transaction_explained',
                                            )}
                                        </p>
                                        <div className="flex justify-center w-full">
                                            <Input
                                                type="number"
                                                fullWidth
                                                variant="bordered"
                                                label={t(
                                                    'popups.items_per_transaction',
                                                )}
                                                defaultValue="junior@nextui.org"
                                                className="max-w-xs"
                                                onChange={changeMaxActions}
                                                value={maxActions}
                                            />
                                        </div>
                                    </div>
                                )}
                            </CardBody>
                        </Card>
                    )}
                </div>
            )}
            <div>
                <div className="relative flex flex-wrap justify-center w-full">
                    <MarketPreviewDetailsTable
                        asset={asset}
                        newOwner={owner}
                        bundleView={false}
                        showData={false}
                        className="w-full"
                    />
                    <MarketInfoDetails
                        asset={asset}
                        listing={listing}
                        currentAsset={0}
                        assets={assets}
                        bundle={bundle}
                        className="w-full my-1"
                    />
                </div>
            </div>
            <div className={'bottom-0'}>
                <Card className="mb-8">
                    <CardBody>
                        <div className="mx-auto mb-2 text-xl font-bold">
                            {amountToBuy
                                ? t('popups.buying_x_name_for_y_in_total', {
                                      x: amountToBuy,
                                      name: name,
                                      y: formatWAX(totalPrice),
                                  })
                                : t(
                                      'popups.are_you_sure_you_want_to_buy_asset_for_amount',
                                      {
                                          amount:
                                              currency === 'WAX'
                                                  ? `${price} WAX`
                                                  : `${price} USD`,
                                          asset: name,
                                      },
                                  )}
                        </div>
                    </CardBody>
                </Card>

                {error ? <ErrorMessage error={error} /> : ''}
                <div className="relative flex justify-end mt-auto">
                    <div className={'mx-2'}>
                        <MainButton
                            className="font-bold bg-red-500 rounded-md"
                            varient="solid"
                            onClick={cancel}
                            size="md"
                        >
                            {t('asset.cancel')}
                        </MainButton>
                    </div>
                    {userName !== seller &&
                    !bought &&
                    [
                        'waxplorercom',
                        'simplemarket',
                        'nft.hive',
                        'atomicmarket',
                    ].includes(market)
                        ? buyField
                        : ''}
                </div>
            </div>
            {isLoading ? (
                buyMultiple ? (
                    <PopupLoadingIndicator
                        text={t('popups.signing_multiple_transactions', {
                            x: currentDisplayAction,
                            y: amountToBuy / maxActions,
                        })}
                        successCount={successCount}
                        errorCount={errorCount}
                        isLoading={isLoading && buyMultiple}
                    />
                ) : (
                    <PopupLoadingIndicator
                        text={t('popups.loading_transaction')}
                        isLoading={isLoading}
                    />
                )
            ) : (
                ''
            )}
        </Popup>
    )
}

export default BuyPopup
